module.exports = __webpack_public_path__ + "img/20_-Hemorrhoid.af78e13f.png";